export default "__VITE_ASSET__02137c7a__"